
export default {
  props: {
    sticky: {
      type: Boolean,
      default: false,
    },
  },
}
